export default "__VITE_ASSET__BsTLi2Gm__"